import { post, get } from "./axios.js"
//  获取微信jssdk配置信息 url debug jsApiList
export function getWxConfig(data) {
  return post('/api/jssdk', data)
}

// 查询app信息
export function getAppInfo (data){
  return post("/api/v2/download", data)
}